<template>
  <div class="kye-report-fzkp004">
    <div class="fzkp004_main-cell"
      :class="[`fzkp004_main-cell-${index}`, value === index ? 'kye-report-fzkp004-selected' : '']"
      v-for="(item, index) in data"
      :key="index"
      @click="cardClick(index)">
      <img
        class="fzkp004_main-icon1"
        v-if="item.mainIcon1"
        @click="handleClick('mainIcon1', index)"
        :src="item.mainIcon1"
        v-events="{ eventsMap, ignoreEventName, args: ['mainIcon1', index, item.mainIcon1]}"
      />
      <div class="fzkp004_main-cell-index">
        <div class="fzkp004_main-title-cell">
          <div
            class="fzkp004_main-title"
            @click="handleClick('mainTitle', index)"
            v-events="{ eventsMap, ignoreEventName, args: ['mainTitle', index, item.mainTitle]}"
          >{{ item.mainTitle }}</div>
          <KyeReportCardQuestion
            class="fzkp004_main-icon2"
            :icon="item.mainIcon2"
            :popover="item.popover"
            @click="handleClick('mainIcon2', index)">
            <slot :name="'tooltip'+index"></slot>
          </KyeReportCardQuestion>
        </div>
        <div
          class="fzkp004_main-index"
          @click="handleClick('mainIndex', index)"
          v-events="{ eventsMap, ignoreEventName, args: ['mainIndex', index, data.item]}"
        >{{ item.mainIndex }}</div>
        <div class="fzkp004_order-cell">
          <img
            class="fzkp004_order-icon1"
            :src="item.orderIcon1 || orderIcon1"
            @click="handleClick('orderIcon1', index)"
            v-events="{ eventsMap, ignoreEventName, args: ['orderIcon1', index, item.orderIcon1]}"
          />
          <div class="fzkp004_order-index-cell" :class="getIndexColor(item.orderIcon2)" v-if="item.orderIndex">
            <div
              class="fzkp004_order-index"
              @click="handleClick('orderIndex', index)"
              v-events="{ eventsMap, ignoreEventName, args: ['orderIndex', index, item.orderIndex]}"
            >{{ item.orderIndex }}</div>
            <kyeReportCardArrow
              @click="handleClick('orderIcon2', index)"
              class="fzkp004_order-icon2"
              :type="item.orderIcon2"
              v-events="{ eventsMap, ignoreEventName, args: ['orderIcon2', index, item.orderIcon2]}"
            ></kyeReportCardArrow>
          </div>
        </div>
      </div>
    </div>
    <card-popover
      :popoverConfig="popoverConfig"
    >
      <slot :name="cardPopoverSlotName"></slot>
    </card-popover>
  </div>
</template>
<script>
import mainIcon1 from '../../asset/images/fzkp004.png'
import orderIcon1 from '../../asset/images/fzkp004-01.png'
import kyeReportCardArrow from '../common/arrow.vue'
import KyeReportCardQuestion from '../common/question.vue'
export default {
  name: 'KyeReportFzkp004',
  components: {
    KyeReportCardQuestion,
    kyeReportCardArrow
  },
  props: {
    data: {
      type: Array,
      default: () => ([])
    },
    value: {
      type: Number,
    }
  },
  data() {
    return {
      mainIcon1,
      orderIcon1
    }
  },
  mounted() {
  },
  methods: {
    handleClick(eventName, index) {
      if (Number(index) >= 0) {
        this.$emit(eventName, index, this.data)
      } else {
        this.$emit(eventName, this.data)
      }
    },
    cardClick(index) {
      this.$emit('cardClick', index, this.data)
      this.$emit('input', index)
    },
    getIndexColor(type) {
      if (type === 'up') {
        return 'index-up-color'
      } else if (type === 'down') {
        return 'index-down-color'
      }
    }
  }
}
</script>
<style lang="scss">
.kye-report-fzkp004 {
  @import '../../style/extend.scss';
  background: #FFFFFF;
  border-radius: 4px;
  flex-direction: row;
  cursor: pointer;
  display: flex;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid #FFFFFF;
  background: linear-gradient(180deg, #FFF2F4 0%, #FFFFFF 50%);
  // padding: 15px 0 12px 0;
  .fzkp004_main-cell {
    padding: 15px 16px 12px;
    display: flex;
    flex: 1;
    flex-direction: row;
    position: relative;
    gap: 6px;
    &:not(:last-child) {
      &::before {
        position: absolute;
        top: 12px;
        right: 0;
        bottom: 12px;
        width: 1px;
        background: #EBEDF5;
        content: '';
      }
    }
    .fzkp004_main-icon1 {
      width: 18px;
      height: 18px;
    }
    .fzkp004_main-cell-index {
      display: flex;
      flex-direction: column;
      gap: 6px;
      .fzkp004_main-title-cell {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
        gap: 4px;
        .fzkp004_main-title {
          color: #333333;
          font-weight: 600;
        }
      }
      .fzkp004_main-index {
        color: #FF5555;
        font-weight: 600;
        font-size: 18px;
      }
      .fzkp004_order-cell {
        display: flex;
        flex-direction: row;
        line-height: 12px;
        gap: 5px;
        .fzkp004_order-icon1 {
          width: 11px;
          height: 11px;
        }
        .fzkp004_order-index-cell {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      }
    }
  }
  .kye-report-fzkp004-selected {
    background: linear-gradient(180deg, #F2F1FF 0%, #FFFFFF 100%);
    &::after {
      position: absolute;
      top: -1px;
      left: 0;
      right: 0;
      height: 2px;
      background: var(--g-color-primary);
      content: '';
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/card/fzkp004/index.vue